/* eslint-disable max-len */
import { StudentTranslations } from '../interfaces/student';

const PolishStudentTranslations: StudentTranslations = {
  gone: 'Tego ucznia już nie ma',
  button: {
    create: 'Dodaj ucznia',
  },
  add: {
    title: 'Dodaj ucznia',
    messages: {
      success: 'Dodano nowego ucznia',
      error: 'Nie udało się dodać nowego ucznia. Spróbuj ponownie za chwilę.',
    },
    joinGroup: 'Dopisz do grupy „{{group}}”',
    group: {
      added: 'Dodano nowego ucznia do grupy „{{group}}”',
      gone: 'Dodano ucznia, ale grupy „{{group}}” już nie ma',
      error: 'Dodano ucznia, ale nie udało się dopisać go do grupy „{{group}}”. Dopiszesz go w „Edytuj grupę”.',
    },
  },
  access: {
    title: 'Udostępnione listy',
    messages: {
      success: 'yay!',
      error: 'Nie udało się.',
    },
    lists: 'Listy',
    empty: 'Ten uczeń nie ma jeszcze list — udostępnisz je ikoną „udostępnij” przy liście na ekranie list',
    hint: 'Kliknięcie nazwy ustawia listę jako aktywną — na niej ruszą gry. Cofnięcie udostępnienia nie usuwa listy, zostaje u Ciebie.',
    selectList: 'Zaznacz listę {{list}}',
    editList: 'Edytuj listę {{list}}',
    editListTooltip: 'edytuj listę',
    revokeList: 'Cofnij udostępnienie {{list}}',
    revokeTooltip: 'cofnij udostępnienie',
    revokeMany: 'Cofnij wiele',
    revokeSelected: 'Cofnij ({{n}})',
    all: 'wszystkie',
    confirm: {
      title: 'Cofnij udostępnienie',
      one: 'Czy na pewno chcesz cofnąć udostępnienie listy "{{list}}" dla {{student}}?',
      many: 'Czy na pewno chcesz cofnąć udostępnienie {{n}} list dla {{student}}? Same listy zostaną u Ciebie.',
      ok: 'Cofnij',
    },
    revoked: {
      one: 'Udostępnienie zostało cofnięte',
      many: 'Cofnięto udostępnienie {{n}} list',
      error: 'Nie udało się cofnąć udostępnienia',
    },
  },
  list: {
    count: {
      one: '{{n}} uczeń',
      few: '{{n}} uczniów',
      many: '{{n}} uczniów',
    },
    search: 'Szukaj ucznia',
    all: 'Wszyscy',
    ungrouped: 'Bez grupy',
    groups: 'Grupy',
    inactive: 'konto nieaktywne',
    belongsTo: 'Należy do grupy „{{group}}”',
    empty: {
      noStudents: 'Nie masz jeszcze uczniów — dodasz ich przyciskiem „Dodaj ucznia”',
      noMatchInGroup: 'Nikt w grupie „{{group}}” nie pasuje do wyszukiwania',
      noMatchUngrouped: 'Nikt bez grupy nie pasuje do wyszukiwania',
      noMatch: 'Nikt nie pasuje do wyszukiwania',
      emptyGroup: 'W tej grupie nie ma jeszcze uczniów — dopiszesz ich w „Edytuj grupę”',
      empty: 'Pusto',
    },
    actions: {
      activity: 'aktywność',
      resendActivation: 'wyślij link aktywacyjny ponownie',
      passwordLink: 'wyślij link do nowego hasła',
      sharedLists: 'udostępnione listy',
      edit: 'edytuj',
      delete: 'usuń',
    },
  },
  // Na telefonie przycisk „Edytuj grupę” pokazuje samo editShort — editRest dopisuje resztę na szerszym ekranie
  groups: {
    new: 'Nowa grupa',
    edit: 'Edytuj grupę',
    editShort: 'Edytuj',
    editRest: ' grupę',
    name: 'Nazwa grupy',
    students: 'Uczniowie',
    selected: 'zaznaczeni: {{n}}',
    noStudents: 'Nie masz jeszcze uczniów',
    delete: 'Usuń grupę',
    deleteConfirm: 'Czy na pewno chcesz usunąć grupę „{{group}}”? Uczniowie i udostępnione im listy zostają.',
    messages: {
      nameRequired: 'Podaj nazwę grupy',
      saved: 'Zapisano grupę „{{group}}”',
      added: 'Dodano grupę „{{group}}”',
      nameTaken: 'Masz już grupę o tej nazwie',
      gone: 'Tej grupy już nie ma',
      studentGone: 'Któregoś z zaznaczonych uczniów już nie ma. Lista jest odświeżona, zapisz ponownie.',
      saveError: 'Nie udało się zapisać grupy',
      deleteError: 'Nie udało się usunąć grupy',
      deleted: 'Usunięto grupę „{{group}}”',
    },
  },
  activity: {
    title: 'Aktywność',
    loadError: 'Nie udało się wczytać aktywności. Spróbuj ponownie później.',
    workTime: 'czas pracy',
    practiceDays: 'dni z ćwiczeniami',
    daysOf: '{{n}} z {{total}}',
    correct: 'poprawnych',
    noPractice: 'brak ćwiczeń',
    deletedList: 'lista usunięta',
    emptyPeriod: 'W ostatnich {{n}} dniach brak ćwiczeń.',
    lastDays: 'Ostatnie {{n}} dni.',
    rules: 'Liczy się czas odpowiadania w grach, a w grze Powtórz — czas słuchania (ta gra nie dodaje odpowiedzi). Czas poza aplikacją się nie liczy. Odsetek poprawnych — tylko z gier, które same sprawdzają odpowiedź. Kwadraciki pod listą to gry w kolejności z menu: morski — uczeń grał w tę grę tego dnia.',
    minutes: '{{n}} min',
    underMinute: '<1 min',
    answers: {
      one: '{{n}} odpowiedź',
      few: '{{n}} odpowiedzi',
      many: '{{n}} odpowiedzi',
    },
  },
  edit: {
    title: 'Edycja',
    messages: {
      success: 'Edytowano ucznia',
      linkSent: 'Zapisano. Wysłano nowy link aktywacyjny na adres {{email}}',
      error: 'Nie udało się edytować ucznia. Spróbuj ponownie za chwilę.',
    },
  },
  activation: {
    title: 'Nowy link aktywacyjny',
    description: 'Wysłać nowy link aktywacyjny na adres {{email}}? Poprzedni link przestanie działać.',
    editAddress: 'Popraw adres',
    submit: 'Wyślij',
    cancel: 'Anuluj',
    messages: {
      success: 'Wysłano nowy link na adres {{email}}',
      error: 'Nie udało się wysłać linku. Spróbuj ponownie za chwilę.',
    },
  },
  // Okienko klucza — przyciski „Popraw adres”, „Anuluj” i „Wyślij” wspólne z okienkiem koperty
  passwordLink: {
    title: 'Link do nowego hasła',
    description: 'Wysłać link do nowego hasła na adres {{email}}? Obecne hasło działa, dopóki uczeń nie ustawi nowego.',
    messages: {
      success: 'Wysłano link do nowego hasła na adres {{email}}',
      error: 'Nie udało się wysłać linku. Spróbuj ponownie za chwilę.',
    },
  },
  delete: {
    title: 'Usuń',
    description: 'Czy jesteś pewien, że chcesz usunąć tego ucznia ?',
    submit: 'Usuń',
    cancel: 'Anuluj',
    messages: {
      success: 'Uczeń został usunięty',
      error: 'Nie udało się usunąć ucznia',
    },
  },
  studentForm: {
    labels: {
      name: 'Imię:',
      surname: 'Nazwisko:',
      email: 'Email:',
      submit: 'Zapisz',
      edit: 'Edytuj',
    },

    validation: {
      name: {
        required: 'Imię jest wymagane',
      },
      surname: {
        required: 'Nazwisko jest wymagane',
      },
      email: {
        required: 'Email jest wymagany',
      },
    },
  },
};

export default PolishStudentTranslations;
